































































import Vue from "vue";

// Icons
import TWIconTwitter from "@/apps/cloned/twitter/components/icons/TWIconTwitter.vue";
import TWIconHome from "@/apps/cloned/twitter/components/icons/TWIconHome.vue";
import TWIconHash from "@/apps/cloned/twitter/components/icons/TWIconHash.vue";
import TWIconBell from "@/apps/cloned/twitter/components/icons/TWIconBell.vue";
import TWIconMessage from "@/apps/cloned/twitter/components/icons/TWIconMessage.vue";
import TWIconBookmark from "@/apps/cloned/twitter/components/icons/TWIconBookmark.vue";
import TWIconList from "@/apps/cloned/twitter/components/icons/TWIconList.vue";
import TWIconProfile from "@/apps/cloned/twitter/components/icons/TWIconProfile.vue";
import TWIconMore from "@/apps/cloned/twitter/components/icons/TWIconMore.vue";

export default Vue.extend({
	name: "TWDefaultLayout",
	components: {
		// Icons
		TWIconTwitter,
		TWIconHome,
		TWIconHash,
		TWIconBell,
		TWIconMessage,
		TWIconBookmark,
		TWIconList,
		TWIconProfile,
		TWIconMore,
	},
	data() {
		return {
			navs: [
				{ name: "Home", path: "/apps/cloned/twitter", icon: "TWIconHome" },
				{
					name: "Explore",
					path: "/apps/cloned/twitter/explore",
					icon: "TWIconHash",
				},
				{
					name: "Notifications",
					path: "/apps/cloned/twitter/notifications",
					icon: "TWIconBell",
				},
				{
					name: "Messages",
					path: "/apps/cloned/twitter/messages",
					icon: "TWIconMessage",
				},
				{
					name: "Bookmarks",
					path: "/apps/cloned/twitter/bookmarks",
					icon: "TWIconBookmark",
				},
				{
					name: "Lists",
					path: "/apps/cloned/twitter/lists",
					icon: "TWIconList",
				},
				{
					name: "Profile",
					path: "/apps/cloned/twitter/:username",
					icon: "TWIconProfile",
				},
				{
					name: "More",
					type: "button",
					path: "/apps/cloned/twitter/explore",
					icon: "TWIconMore",
				},
			],
		};
	},
});
